module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-page"
  }, [_c('nav', [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bonus'
      }
    }
  }, [_vm._v("2015精选")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "article-list clearfix"
  }, [_c('ul', {
    staticClass: "btn-group"
  }, [_c('li', {
    class: {
      active: _vm.show === 'hot'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('hot')
      }
    }
  }, [_vm._v("热门")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'new'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('new')
      }
    }
  }, [_vm._v("新上榜")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'daily'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('daily')
      }
    }
  }, [_vm._v("日报")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'weekhot'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'weekhot'
      }
    }
  }, [_vm._v("七日热门")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'monthhot'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'monthhot'
      }
    }
  }, [_vm._v("三十日热门")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'reward'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'reward'
      }
    }
  }, [_vm._v("有奖活动")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'publish'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'publish'
      }
    }
  }, [_vm._v("简书出版")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'video'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'vedio'
      }
    }
  }, [_vm._v("简书播客")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'hotnews'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'hotnews'
      }
    }
  }, [_vm._v("时事热闻")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'choice'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'choice'
      }
    }
  }, [_vm._v("专题精选")])], 1)]), _vm._v(" "), _c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showbar"
  }, [_c('div', {
    staticClass: "cover-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "text-shadow": "1px 1px 1px #000000"
    }
  }, [_c('h1', [_vm._v("简书")]), _vm._v(" "), _c('h3', [_vm._v("交流故事，沟通想法")]), _vm._v(" "), _c('p', [_vm._v("一个基于内容分享的社区")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("提笔写篇文章")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-text fir"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("发现")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "search clearfloat"
  }, [_c('span', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "fa fa-seaSrch"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b1bb0bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 60
// module chunks = 0